module.exports = __webpack_public_path__ + "static/media/wand-magic.320f4392.svg";